import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  getUpsShippingLabelDataUrl,
  printUpsShippingLabels,
} from "../card-order.util";
import type { UpsShippingLabelsDialogParams } from "../card-orders.interface";

@Component({
  selector: "app-ups-shipping-labels-dialog",
  templateUrl: "./ups-shipping-labels-dialog.component.html",
  styleUrls: ["./ups-shipping-labels-dialog.component.scss"],
  standalone: false,
})
export class UpsShippingLabelsDialogComponent {
  readonly getLabelDataUrl = getUpsShippingLabelDataUrl;
  printing = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UpsShippingLabelsDialogParams,
    private readonly dialogRef: MatDialogRef<UpsShippingLabelsDialogComponent>,
  ) {}

  printLabel(label: UpsShippingLabelsDialogParams["labels"][number]): void {
    if (this.printing) {
      return;
    }
    this.printing = true;
    try {
      printUpsShippingLabels([
        {
          shippingLabelGifBase64: label.shippingLabelGifBase64,
          trackingNumber: label.trackingNumber,
        },
      ]);
    } finally {
      this.printing = false;
    }
  }

  printAll(): void {
    if (this.printing) {
      return;
    }
    this.printing = true;
    try {
      printUpsShippingLabels(
        this.data.labels.map((label) => ({
          shippingLabelGifBase64: label.shippingLabelGifBase64,
          trackingNumber: label.trackingNumber,
        })),
      );
    } finally {
      this.printing = false;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
